import React, { useState, useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import axios from 'axios'
import { getDesignationData, getEmploymentTypeData, getRoleData, getReportingManagerData, getHRData } from '../../../CommonFunction'
import { API_BASE_URL } from '../../../../utils/contants'
import { setupAxios } from '../../../modules/auth'

interface UserDetailsTableProps {
  data: any
  canEdit: boolean
  onSave?: (updatedData: any) => void
  onResetPassword?: () => void
  visibleSections?: {
    personal?: boolean
    work?: boolean
    management?: boolean
    bank?: boolean
  }
}


const WEEK_DAYS = [
  { label: 'Mon', value: 'Monday' },
  { label: 'Tue', value: 'Tuesday' },
  { label: 'Wed', value: 'Wednesday' },
  { label: 'Thu', value: 'Thursday' },
  { label: 'Fri', value: 'Friday' },
  { label: 'Sat', value: 'Saturday' },
  { label: 'Sun', value: 'Sunday' },
]

const UserDetailsTable: React.FC<UserDetailsTableProps> = ({
  data,
  canEdit,
  onSave,
  onResetPassword,
  visibleSections = { personal: true, work: true, management: true, bank: true }
}) => {
  // Location Master
  const [locations, setLocations] = useState<
    { label: string; value: string }[]
  >([])

  // Reporting Manager Name Show
  const getReportingManagerName = () => {
  const rm = data?.associates?.find(
    (a: any) => a.associateType === 'RM'
  )
  return rm?.userAssociate
    ? `${rm.userAssociate.firstName} ${rm.userAssociate.lastName}`
    : 'N/A'
  }
  // HR Manager Name Show
  const getHRManagerName = () => {
    const hr = data?.associates?.find(
      (a: any) => a.associateType === 'HR'
    )
    return hr?.userAssociate
      ? `${hr.userAssociate.firstName} ${hr.userAssociate.lastName}`
      : 'N/A'
  }


  const [isEditing, setIsEditing] = useState(false)
  const [profileImageFailed, setProfileImageFailed] = useState(false)
  const [designations, setDesignations] = useState<{ label: string, value: string }[]>([])
  const [employmentTypes, setEmploymentTypes] = useState<{ label: string, value: string }[]>([])
  const [roles, setRoles] = useState<{ label: string, value: string }[]>([])
  const [reportingManagers, setReportingManagers] = useState<{ label: string, value: string }[]>([])
  const [hrUsers, setHRUsers] = useState<{ label: string, value: string }[]>([])
  const [workingShifts, setWorkingShifts] = useState<{ label: string, value: string, startTime: string, endTime: string }[]>([])
  const [weekendError, setWeekendError] = useState('')
  const [editData, setEditData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    personalEmail: '',
    mobile: '',
    dateOfBirth: '',
    gender: '',
    address: '',
    employeeCode: '',
    joiningDate: '',
    lastWorkingDate: '',
    designationId: '',
    employmentId: '',
    roleId: '',
    reportingManagerId: '',
    hrManagerId: '',
    workingShiftId: '',
    inTime: '',
    outTime: '',
    departmentId: '',
    locationId: '',
    weekendDays: [] as string[],
    //Permanent Address
    permanentAddress: '',
    emergencyName: '',  //Emergency Name
    emergencyMobile: '',//Emergency Mobile
    emergencyRelation: '',//Emergency Relation
    isPoshCommitteeMember: false, //POSH Committee Member

    bankDetails: {
      bankName: '',
      branchName: '',
      accountNumber: '',
      ifscCode: '',
      panNumber: '',
      aadharNumber: '',
    }
  })

  // Initialize edit data when data changes
  useEffect(() => {
    if (data) {
      setProfileImageFailed(false)
      const bankDetails = data?.bankDetails?.[0] || {}

      // Get RM and HR IDs from associates array
      const rmAssociate = data?.associates?.find(item => item.associateType === 'RM')
      const hrAssociate = data?.associates?.find(item => item.associateType === 'HR')

      setEditData({
        firstName: data?.firstName || '',
        middleName: data?.middleName || '',
        lastName: data?.lastName || '',
        email: data?.email || '',
        personalEmail: data?.personalEmail || '',
        mobile: data?.mobile || '',
        dateOfBirth: data?.dateOfBirth ? data.dateOfBirth.split('T')[0] : '',
        gender: data?.gender || '',
        address: data?.address || '',
        employeeCode: data?.employeeCode || '',
        joiningDate: data?.joiningDate ? data.joiningDate.split('T')[0] : '',
        lastWorkingDate: data?.lastWorkingDate ? data.lastWorkingDate.split('T')[0] : '',
        designationId: data?.designation?.id || '',
        employmentId: data?.employment?.id || '',
        roleId: data?.role?.id || data?.userRoles?.[0]?.roleId || data?.userRoles?.[0]?.role?.id || data?.userRoles?.[0]?.id || '',
        reportingManagerId: rmAssociate?.userAssociate?.id || '',
        hrManagerId: hrAssociate?.userAssociate?.id || '',

        workingShiftId: data?.workingShift?.id || data?.workingShiftId || '',
        inTime: data?.workingShift?.startTime || data?.inTime || '',
        outTime: data?.workingShift?.endTime || data?.outTime || '',
        departmentId: data?.department?.id
          ? String(data.department.id)
          : '',
        locationId: data?.locationId || data?.location?.id || '',
        weekendDays: data?.weekendDays || [],
        permanentAddress: data?.permanentAddress || '',
        emergencyName: data?.emergencyName || '',
        emergencyMobile: data?.emergencyMobile || '',
        emergencyRelation: data?.emergencyRelation || '',
        isPoshCommitteeMember: data?.isPoshCommitteeMember || false,

        bankDetails: {
          bankName: bankDetails?.bankName || '',
          branchName: bankDetails?.branchName || '',
          accountNumber: bankDetails?.accountNumber || '',
          ifscCode: bankDetails?.ifscCode || '',
          panNumber: bankDetails?.panNumber || '',
          aadharNumber: bankDetails?.aadharNumber || ''
        }
      })
    }
  }, [data])
  const [departments, setDepartments] = useState<{ label: string, value: string }[]>([])

  // Fetch designations, employment types, and working shifts when component mounts
  // useEffect(() => {
  //   const fetchDropdownData = async () => {
  //     try {

  //       // Use the same functions as CreateUser component
  //       getDesignationData(setDesignations)
  //       getEmploymentTypeData(setEmploymentTypes)
  //       getRoleData(setRoles)
  //       getReportingManagerData(setReportingManagers)
  //       getHRData(setHRUsers)

  //       // Fetch working shifts (only active shifts)
  //       const {token, tenantId} = setupAxios()
  //       const response = await axios.get(`${API_BASE_URL}/working-shift-master?active=true`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       })

  //       if (response.data?.statusCode === 200) {
  //         const shifts = response.data.data.map((shift: any) => ({
  //           label: shift.shiftName,
  //           value: shift.id,
  //           startTime: shift.startTime,
  //           endTime: shift.endTime,
  //         }))
  //         setWorkingShifts(shifts)
  //       }
  //     } catch (error) {
  //       console.error('Error fetching dropdown data:', error)
  //       toast.error('Failed to load dropdown options')
  //     }
  //   }

  //   fetchDropdownData()
  // }, [])
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const { token } = setupAxios()   // 🔥 MOVE THIS TO TOP

        getDesignationData(setDesignations)
        getEmploymentTypeData(setEmploymentTypes)
        getRoleData(setRoles)
        getReportingManagerData(setReportingManagers)
        getHRData(setHRUsers)

        //  Fetch Active Office locations
        const locationRes = await axios.get(
          // `${API_BASE_URL}/location-master?activeOnly=true`,
          `${API_BASE_URL}/location-master?active=true`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )

        if (locationRes.data?.statusCode === 200) {
          setLocations(
            locationRes.data.data.map((loc: any) => ({
              label: `${loc.name} (${loc.city})`,
              value: loc.id,
            }))
          )
        }

        //  Fetch shifts
        const shiftRes = await axios.get(
          `${API_BASE_URL}/working-shift-master?active=true`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )

      // if (shiftRes.data?.statusCode === 200) {
      //   setWorkingShifts(
      //     shiftRes.data.data.map((s: any) => ({
      //       label: s.shiftName,
      //       value: s.id,
      //       startTime: s.startTime,
      //       endTime: s.endTime,
      //     }))
      //     setWorkingShifts(shifts)
      //   }
      if (shiftRes.data?.statusCode === 200) {
          if (shiftRes.data?.statusCode === 200) {
            const shifts = shiftRes.data.data.map((s: any) => ({
              label: s.shiftName,
              value: s.id,
              startTime: s.startTime,
              endTime: s.endTime,
            }));
            setWorkingShifts(shifts);
          }
        }
        // Fetch departments
        const deptResponse = await axios.get(`${API_BASE_URL}/departments`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        console.log('Departments API:', deptResponse.data)
        const deptData = deptResponse.data?.data   //  THIS IS THE FIX

        if (Array.isArray(deptData)) {
          const depts = deptData.map((dept: any) => ({
            label: dept.name,
            value: String(dept.id),
          }))
          setDepartments(depts)
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error)
        toast.error('Failed to load dropdown options')
      }
    }

    fetchDropdownData()
  }, [])


  const handleEdit = () => {
    setIsEditing(true)
  }

  const handleCancel = () => {
    setIsEditing(false)
    // Reset to original data
    const bankDetails = data?.bankDetails?.[0] || {}

    // Get RM and HR IDs from associates array
    const rmAssociate = data?.associates?.find(item => item.associateType === 'RM')
    const hrAssociate = data?.associates?.find(item => item.associateType === 'HR')

    setEditData({
      firstName: data?.firstName || '',
      middleName: data?.middleName || '',
      lastName: data?.lastName || '',
      email: data?.email || '',
      personalEmail: data?.personalEmail || '',
      mobile: data?.mobile || '',
      dateOfBirth: data?.dateOfBirth ? data.dateOfBirth.split('T')[0] : '',
      gender: data?.gender || '',
      address: data?.address || '',
      employeeCode: data?.employeeCode || '',
      joiningDate: data?.joiningDate ? data.joiningDate.split('T')[0] : '',
      lastWorkingDate: data?.lastWorkingDate ? data.lastWorkingDate.split('T')[0] : '',
      designationId: data?.designation?.id || '',
      employmentId: data?.employment?.id || '',
      roleId: data?.role?.id || data?.userRoles?.[0]?.roleId || data?.userRoles?.[0]?.role?.id || data?.userRoles?.[0]?.id || '',
      reportingManagerId: rmAssociate?.userAssociate?.id || '',
      hrManagerId: hrAssociate?.userAssociate?.id || '',
      workingShiftId: data?.workingShiftId || '',
      inTime: data?.inTime || '',
      outTime: data?.outTime || '',
      departmentId: data?.department?.id
        ? String(data.department.id)
        : '',
      locationId: data?.locationId || data?.location?.id || '',
      weekendDays: data?.weekendDays || [],
      permanentAddress: data?.permanentAddress || '',
      emergencyName: data?.emergencyName || '',
      emergencyMobile: data?.emergencyMobile || '',
      emergencyRelation: data?.emergencyRelation || '',
      isPoshCommitteeMember: data?.isPoshCommitteeMember || false,

      bankDetails: {
        bankName: bankDetails?.bankName || '',
        branchName: bankDetails?.branchName || '',
        accountNumber: bankDetails?.accountNumber || '',
        ifscCode: bankDetails?.ifscCode || '',
        panNumber: bankDetails?.panNumber || '',
        aadharNumber: bankDetails?.aadharNumber || ''
      }
    })
  }

  // const handleSave = () => {
  //   if (onSave) {
  //     onSave(editData)
  //     setIsEditing(false)
  //   }
  // }
  const handleSave = () => {
    if (!onSave) return

    const payload = {
      ...editData,
      departmentId: editData.departmentId || null, //  IMPORTANT FIX
      
    }

    onSave(payload)
    setIsEditing(false)
  }

  const handleInputChange = (field: string, value: string | boolean) => {
    if (field === 'isPoshCommitteeMember') {
      setEditData(prev => ({ ...prev, [field]: value as boolean }))
    } else if (field === 'workingShiftId') {
      // When shift is selected, auto-update inTime and outTime
      const selectedShift = workingShifts.find(shift => shift.value === value)
      if (selectedShift) {
        setEditData(prev => ({
          ...prev,
          workingShiftId: value as string,
          inTime: selectedShift.startTime,
          outTime: selectedShift.endTime,
        }))
      } else {
        setEditData(prev => ({ ...prev, [field]: value as string }))
      }
    } else if (field.startsWith('bankDetails.')) {
      const bankField = field.replace('bankDetails.', '')
      setEditData(prev => ({
        ...prev,
        bankDetails: {
          ...prev.bankDetails,
          [bankField]: value
        }
      }))
    } else {
      setEditData(prev => ({
        ...prev,
        [field]: value as string
      }))
    }
  }

  const handleResetPassword = () => {
    if (onResetPassword) {
      onResetPassword()
    } else {
      toast.info('Reset password functionality to be implemented')
    }
  }

  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A'
    return new Date(dateString).toLocaleDateString('en-GB')
  }

  const formatTime = (timeString: string) => {
    if (!timeString) return 'N/A'
    return timeString
  }

  const getDisplayValue = (field: string, value: string, options?: { label: string, value: string }[]) => {
    if (!value) return 'N/A'

    if (options && options.length > 0) {
      const option = options.find(opt => opt.value === value)
      return option ? option.label : value
    }

    return value
  }

  const bankDetails = data?.bankDetails?.[0]

  const renderEditableField = (
    field: string,
    value: string,
    type: string = 'text',
    options?: { label: string, value: string }[]
  ) => {
    if (!isEditing) {
      if (type === 'date' && value) {
        return formatDate(value)
      }
      if (type === 'select' && options) {
        return getDisplayValue(field, value, options)
      }
      return value || 'N/A'
    }

    if (type === 'select' && options) {
      const currentValue = field.startsWith('bankDetails.')
        ? editData.bankDetails[field.replace('bankDetails.', '')]
        : editData[field as keyof typeof editData]

      return (
        <Form.Select
          size="sm"
          value={currentValue || ''}
          onChange={(e) => handleInputChange(field, e.target.value)}
        >
          <option value="">Select...</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      )
    }

    const inputValue = field.startsWith('bankDetails.')
      ? editData.bankDetails[field.replace('bankDetails.', '')]
      : editData[field as keyof typeof editData]

    return (
      <Form.Control
        size="sm"
        type={type}
        value={inputValue || ''}
        onChange={(e) => handleInputChange(field, e.target.value)}
      />
    )
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className={`card-header ${isEditing ? 'bg-light-warning' : ''}`}>
        <div className='card-title m-0'>
          <img
            src={profileImageFailed ? '/media/avatars/blank.png' : (data?.profileImageUrl || data?.profileImage || data?.profilePictureUrl || data?.profilePicture || data?.avatarUrl || data?.avatar || data?.imageUrl || '/media/avatars/blank.png')}
            alt={`${data?.firstName || 'User'} profile`}
            onError={() => setProfileImageFailed(true)}
            className='rounded-circle me-3'
            style={{ width: 56, height: 56, objectFit: 'cover' }}
          />
          <h3 className='fw-bolder m-0'>
            {isEditing ? (
              <>
                <i className='fas fa-edit me-2 text-warning'></i>
                Editing Employee Information
              </>
            ) : (
              'Employee Information'
            )}
          </h3>
        </div>
        <div className='card-toolbar'>
          {canEdit && !isEditing ? (
            <Button variant='primary' size='sm' onClick={handleEdit}>
              <i className='fas fa-edit me-2'></i>
              Edit Details
            </Button>
          ) : canEdit && isEditing ? (
            <div className='d-flex gap-2'>
              <Button variant='success' size='sm' onClick={handleSave}>
                <i className='fas fa-save me-1'></i>
                Save
              </Button>
              <Button variant='secondary' size='sm' onClick={handleCancel}>
                <i className='fas fa-times me-1'></i>
                Cancel
              </Button>
            </div>
          ) : null}
        </div>
      </div>

      <div className='card-body p-0'>
        {/* Personal Information Section */}
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='required ps-4 min-w-200px'>Personal Information</th>
                <th className='required min-w-200px'>Details</th>
                <th className='required min-w-200px'>Work Information</th>
                <th className='required min-w-200px pe-4'>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-user me-2 text-primary'></i>Full Name
                </td>
                <td className='text-dark'>
                  {isEditing ? (
                    <div className='d-flex gap-1'>
                      <Form.Control
                        size="sm"
                        placeholder="First Name"
                        value={editData.firstName || ''}
                        onChange={(e) => handleInputChange('firstName', e.target.value)}
                        style={{ width: '48%' }}
                      />
                      <Form.Control
                        size="sm"
                        placeholder="Middle Name"
                        value={editData.middleName || ''}
                        onChange={(e) => handleInputChange('middleName', e.target.value)}
                        style={{ width: '32%' }}
                      />
                      <Form.Control
                        size="sm"
                        placeholder="Last Name"
                        value={editData.lastName || ''}
                        onChange={(e) => handleInputChange('lastName', e.target.value)}
                        style={{ width: '48%' }}
                      />
                    </div>
                  ) : (
                    // <span className='fw-bolder'>{data?.firstName} {data?.lastName}</span>
                    <span className='fw-bolder'>
                      {[data?.firstName, data?.middleName, data?.lastName]
                        .filter(Boolean)
                        .join(' ')}
                    </span>
                  )}
                </td>
                <td className='required fw-bold text-gray-600'>
                  <i className='fas fa-id-card me-2 text-primary'></i>Employee Code
                </td>
                <td className='text-dark'>
                  {renderEditableField('employeeCode', data?.employeeCode)}
                </td>
              </tr>
              
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-envelope me-2 text-primary'></i>Email
                </td>
                <td className='text-dark'>
                  {renderEditableField('email', data?.email, 'email')}
                </td>
                <td className='required fw-bold text-gray-600'>
                  <i className='fas fa-briefcase me-2 text-primary'></i>Designation
                </td>
                <td className='text-dark'>
                  {isEditing ? (
                    renderEditableField('designationId', editData.designationId, 'select', designations)
                  ) : (
                    data?.designation?.name || 'N/A'
                  )}
                </td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-envelope-open me-2 text-primary'></i>Personal Email
                </td>
                <td className='text-dark'>
                  {renderEditableField('personalEmail', data?.personalEmail, 'email')}
                </td>
                {/* <td className='required fw-bold text-gray-600'>Employment Type</td> */}
                <td className='required fw-bold text-gray-600'>
                  <i className='fas fa-id-badge me-2 text-primary'></i>
                  Employment Type
                </td>
                <td className='text-dark'>
                  {isEditing ? (
                    renderEditableField('employmentId', editData.employmentId, 'select', employmentTypes)
                  ) : (
                    data?.employment?.name || 'N/A'
                  )}
                </td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-mobile-alt me-2 text-primary'></i>Mobile
                </td>
                <td className='text-dark'>
                  {renderEditableField('mobile', data?.mobile, 'tel')}
                </td>
                <td className='required fw-bold text-gray-600'>
                  <i className='fas fa-calendar-plus me-2 text-primary'></i>Joining Date
                </td>
                <td className='text-dark'>
                  {renderEditableField('joiningDate', data?.joiningDate, 'date')}
                </td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-birthday-cake me-2 text-primary'></i>Date of Birth
                </td>
                <td className='text-dark'>
                  {renderEditableField('dateOfBirth', data?.dateOfBirth, 'date')}
                </td>
                <td className='fw-bold text-gray-600'>
                  <i className='fas fa-calendar-minus me-2 text-primary'></i>Last Working Date
                </td>
                <td className='text-dark'>
                  {renderEditableField('lastWorkingDate', data?.lastWorkingDate, 'date')}
                </td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-venus-mars me-2 text-primary'></i>Gender
                </td>
                <td className='text-dark'>
                  {renderEditableField('gender', data?.gender, 'select', [
                    { label: 'Male', value: 'Male' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Other', value: 'Other' }
                  ])}
                </td>
                <td className='required fw-bold text-gray-600'>
                  <i className='fas fa-clock me-2 text-primary'></i>Work Timings
                </td>
                
                <td className='text-dark'>
                  {isEditing ? (
                    // <div className='d-flex flex-column gap-1'>
                    //   <Form.Select
                    //     size="sm"
                    //     value={editData.workingShiftId}
                    //     onChange={(e) => handleInputChange('workingShiftId', e.target.value)}
                    //     style={{width: '280px'}}
                    //     required
                    //   >
                    //     <option value="">Select Working Shift</option>
                    //     {workingShifts.map((shift) => (
                    //       <option key={shift.value} value={shift.value}>
                    //         {shift.label}
                    //       </option>
                    //     ))}
                    //   </Form.Select>
                    //   {editData.workingShiftId && (
                    //     <small className='text-muted'>
                    //       <i className='fas fa-clock me-1'></i>
                    //       {editData.inTime} - {editData.outTime}
                    //     </small>
                    //   )}
                    // </div>
                    

                    <div className='required d-flex flex-column gap-1'>
                      <Form.Select
                        size="sm"
                        value={editData.workingShiftId || ''}
                        onChange={(e) => handleInputChange('workingShiftId', e.target.value)}
                        style={{ width: '280px' }}
                        required
                      >
                        <option value="">Select Working Shift</option>

                        {workingShifts.map((shift) => (
                          <option key={shift.value} value={shift.value}>
                            {shift.label} ({shift.startTime} - {shift.endTime})
                          </option>
                        ))}
                      </Form.Select>

                      {editData.workingShiftId && (
                        <small className='text-muted'>
                          <i className='fas fa-clock me-1'></i>
                          {editData.inTime} - {editData.outTime}
                        </small>
                      )}
                    </div>

                  ) : (
                    <span>
                      {data?.workingShift
                        ? `${formatTime(data.workingShift.startTime)} - ${formatTime(
                          data.workingShift.endTime
                        )}`
                        : data?.inTime && data?.outTime
                          ? `${formatTime(data.inTime)} - ${formatTime(data.outTime)}`
                          : 'N/A'}
                    </span>
                  )}
                </td>
              </tr>
              <tr>

              {/* LEFT SIDE Department */}
              <td className='required ps-4 fw-bold text-gray-600'>
                <i className='fas fa-building me-2 text-primary'></i>
                Department
              </td>

              <td className='text-dark'>
                  {isEditing ? (
                    renderEditableField('departmentId', editData.departmentId, 'select', departments)
                  ) : (
                    data?.department?.name || 'N/A'
                  )}
              </td>

              {/* RIGHT SIDE */}
              <td className='fw-bold text-gray-600'>
                <i className='fas fa-info-circle me-2 text-primary'></i>
                Status
              </td>

              <td className='text-dark pe-4'>
                {canEdit ? (
                   <div className='form-check form-switch d-flex align-items-center' style={{ maxWidth: '180px' }}>
                      <input
                        className='form-check-input me-2'
                        type='checkbox'
                        id='statusToggle'
                        checked={data?.status === 'Active'}
                        onChange={(e) => onSave?.({ status: e.target.checked ? 'Active' : 'Inactive' })}
                      />
                      <label className='form-check-label' htmlFor='statusToggle'>
                        {data?.status === 'Active' ? 'Active' : 'Inactive'}
                      </label>
                    </div>
                ) : (
                    <span className={`badge fs-7 ${data?.status === 'Active' ? 'badge-light-success' : 'badge-light-danger'}`}>
                      <i className={`fas ${data?.status === 'Active' ? 'fa-check-circle' : 'fa-times-circle'} me-1`}></i>
                      {data?.status || 'N/A'}
                    </span>
                  )}
                </td>
              </tr>
              
              {/* ================= ADDRESS ================= */}
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-map-marker-alt me-2 text-primary'></i>
                  Current Address
                </td>
                <td className='text-dark'>
                  {isEditing ? (
                    <Form.Control
                      as="textarea"
                      rows={2}
                      size="sm"
                      value={editData.address}
                      onChange={(e) => handleInputChange('address', e.target.value)}
                    />
                  ) : (
                    data?.address || 'N/A'
                  )}
                </td>
                <td></td>
                <td></td>
              </tr>

              {/* ================= PERMANENT ADDRESS ================= */}
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-home me-2 text-primary'></i>
                  Permanent Address
                </td>
                <td className='text-dark'>
                  {isEditing ? (
                    <Form.Control
                      as="textarea"
                      rows={2}
                      size="sm"
                      value={editData.permanentAddress}
                      onChange={(e) =>
                        handleInputChange('permanentAddress', e.target.value)
                      }
                    />
                  ) : (
                    data?.permanentAddress || 'N/A'
                  )}
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-calendar-week me-2 text-primary'></i>
                  Week-Off
                </td>

                <td className='text-dark'>
                  {isEditing ? (
                      <>
                        <div className="d-flex flex-wrap gap-3">
                          {WEEK_DAYS.map((day) => (
                            <label
                              key={day.value}
                              className="form-check d-flex align-items-center gap-2"
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={editData.weekendDays.includes(day.value)}
                                onChange={(e) => {
                                  const checked = e.target.checked
                                  let updated = [...editData.weekendDays]

                                  if (checked) {
                                    if (updated.length >= 2) {
                                      setWeekendError('Maximum 2 weekend days allowed')
                                      return
                                    }
                                    updated.push(day.value)
                                  } else {
                                    updated = updated.filter(d => d !== day.value)
                                  }

                                  setWeekendError('')
                                  setEditData(prev => ({
                                    ...prev,
                                    weekendDays: updated,
                                  }))
                                }}
                              />
                              <span>{day.label}</span>
                            </label>
                          ))}
                        </div>

                        {weekendError && (
                          <div className="text-danger fs-7 mt-1">{weekendError}</div>
                        )}

                        <div className="text-muted fs-7">
                          Select minimum 1 and maximum 2 days
                        </div>
                      </>
                     ) : (
                      <span>
                        {Array.isArray(data?.weekendDays) && data.weekendDays.length > 0
                          ? data.weekendDays.join(', ')
                          : 'N/A'}
                      </span>
                    )}
                </td>

                <td></td>
                <td></td>
              </tr>
              <tr>
                <td className='required ps-4 fw-bold text-gray-600'>
                  <i className='fas fa-building me-2 text-primary'></i>
                  Office Location
                </td>

                <td className='text-dark'>
                  {isEditing ? (
                      <Form.Select
                        size="sm"
                        value={editData.locationId || ''}
                        onChange={(e) =>
                          setEditData(prev => ({
                            ...prev,
                            locationId: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Office Location</option>
                        {locations.map(loc => (
                          <option key={loc.value} value={loc.value}>
                            {loc.label}
                          </option>
                        ))}
                      </Form.Select>
                    ) : (
                      data?.location
                        ? `${data.location.name} - ${data.location.city}`
                        : 'N/A'
                    )}
                </td>

                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Management Information Section */}
        <div className='separator my-4'></div>
          <div className='table-responsive'>
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-bold text-muted bg-light'>
                  <th className='ps-4 min-w-200px'>Management & Roles</th>
                  <th className='min-w-300px'>Details</th>
                  <th className='min-w-200px'>Bank Information</th>
                  <th className='min-w-200px pe-4'>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='required ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-users me-2 text-primary'></i>Reporting Manager
                  </td>
                  {/* Reporting Manager Id Show */}
                  {/* <td className='text-dark'>
                    {renderEditableField('reportingManagerId', editData.reportingManagerId, 'select', reportingManagers)}
                  </td> */}
                  {/* Reporting Manager Name Show */}
                  <td className='text-dark'>
                    {isEditing ? (
                      renderEditableField(
                        'reportingManagerId',
                        editData.reportingManagerId,
                        'select',
                        reportingManagers
                      )
                    ) : (
                      <span>{getReportingManagerName()}</span>
                    )}
                  </td>

                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-university me-2 text-primary'></i>Bank Name
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('bankDetails.bankName', bankDetails?.bankName)}
                  </td>
                </tr>
                <tr>
                  <td className='required ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-user-tie me-2 text-primary'></i>HR Manager
                  </td>
                  
                  {/* HR Manager Id show */}
                  {/* <td className='text-dark'>
                    {renderEditableField('hrManagerId', editData.hrManagerId, 'select', hrUsers)}
                  </td> */}
                  {/* HR Manager Name Show*/}
                  <td className='text-dark'>
                    {isEditing ? (
                      renderEditableField(
                        'hrManagerId',
                        editData.hrManagerId,
                        'select',
                        hrUsers
                      )
                    ) : (
                      <span>{getHRManagerName()}</span>
                    )}
                  </td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-code-branch me-2 text-primary'></i>Branch Name
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('bankDetails.branchName', bankDetails?.branchName)}
                  </td>
                </tr>
                <tr>
                  <td className='required ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-user-tag me-2 text-primary'></i>User Roles
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('roleId', editData.roleId, 'select', roles)}
                  </td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-credit-card me-2 text-primary'></i>Account Number
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('bankDetails.accountNumber', bankDetails?.accountNumber)}
                  </td>
                </tr>
                <tr>
                  <td className='ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-shield-alt me-2 text-primary'></i>Member of POSH Committee
                  </td>
                  <td className='text-dark'>
                    {isEditing ? (
                      <div className='form-check form-switch d-flex align-items-center'>
                        <input
                          className='form-check-input me-2'
                          type='checkbox'
                          checked={editData.isPoshCommitteeMember}
                          onChange={(e) => handleInputChange('isPoshCommitteeMember', e.target.checked)}
                        />
                        <label className='form-check-label'>
                          {editData.isPoshCommitteeMember ? 'Yes' : 'No'}
                        </label>
                      </div>
                    ) : (
                      data?.isPoshCommitteeMember ? (
                        <span className='badge badge-success'>Yes</span>
                      ) : (
                        <span className='badge badge-secondary'>No</span>
                      )
                    )}
                  </td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-code me-2 text-primary'></i>IFSC Code
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('bankDetails.ifscCode', bankDetails?.ifscCode)}
                  </td>
                </tr>
                <tr>
                  <td className='ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-clock me-2 text-primary'></i>Last Updated
                  </td>
                  <td className='text-dark'>{formatDate(data?.updatedAt)}</td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-id-card me-2 text-primary'></i>PAN Number
                  </td>
                  <td className='text-dark'>
                    {renderEditableField('bankDetails.panNumber', bankDetails?.panNumber)}
                  </td>
                </tr>
                <tr>
                  <td className='ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-shield-alt me-2 text-primary'></i>Password Changed
                  </td>
                  <td className='text-dark'>
                    {data?.isPasswordChanged ? (
                      <span className='badge badge-success'>Yes</span>
                    ) : (
                      <span className='badge badge-warning'>No</span>
                    )}
                  </td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-id-card-alt me-2 text-primary'></i>Aadhar Number
                  </td>
                  <td className='text-dark pe-4'>
                    {renderEditableField('bankDetails.aadharNumber', bankDetails?.aadharNumber)}
                  </td>
                </tr>
                <tr>
                  <td className='ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-calendar-check me-2 text-primary'></i>Account Created
                  </td>
                  <td className='text-dark'>{formatDate(data?.createdAt)}</td>
                  <td className='fw-bold text-gray-600'>
                    <i className='fas fa-clock me-2 text-primary'></i>Last Password Change
                  </td>
                  <td className='text-dark pe-4 d-flex align-items-center justify-content-between'>
                    <span>{formatDate(data?.updatedAt)}</span>
                    {canEdit && (
                      <Button variant='outline-primary' size='sm' onClick={handleResetPassword}>
                        <i className='fas fa-sync-alt me-1'></i>
                        Reset
                      </Button>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className='ps-4 fw-bold text-gray-600'>
                    <i className='fas fa-key me-2 text-primary'></i>Password Status
                  </td>
                  <td className='text-dark'>
                    <div className='d-flex align-items-center'>
                      <span className='me-3'>••••••••••••</span>
                      {data?.isPasswordChanged ? (
                        <span className='badge badge-success'>Changed</span>
                      ) : (
                        <span className='badge badge-warning'>Default</span>
                      )}
                    </div>
                  </td>
                  <td colSpan={2}></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="separator my-4"></div>
            <h5 className="required ps-4 fw-bold text-danger">
              Emergency Contact Details
            </h5>

            <table className="table table-row-bordered">
              <tbody>

                <tr>
                  <td className="required ps-4 fw-bold">
                    Emergency Name
                  </td>
                  <td>
                    {isEditing ? (
                      <Form.Control
                        size="sm"
                        value={editData.emergencyName}
                        onChange={(e) =>
                          handleInputChange('emergencyName', e.target.value)
                        }
                      />
                    ) : (
                      data?.emergencyName || 'N/A'
                    )}
                  </td>
                </tr>

                <tr>
                  <td className="required ps-4 fw-bold">
                    Emergency Contact Number
                    <div className="text-muted fw-normal" style={{ fontSize: "12px" }}>
                      Format: Mention country code (e.g. +91) followed by the number. 
                      Example: +918390870115
                    </div>
                  </td>
                  <td>
                    {isEditing ? (
                      <Form.Control
                        size="sm"
                        value={editData.emergencyMobile}
                        onChange={(e) =>
                          handleInputChange('emergencyMobile', e.target.value)
                        }
                        placeholder="+91XXXXXXXXXX"
                      />
                    ) : (
                      data?.emergencyMobile
                        ? ` ${data.emergencyMobile}`
                        : 'N/A'
                    )}
                  </td>
                </tr>

                <tr>
                  <td className="required ps-4 fw-bold">
                    Relation
                  </td>
                  <td>
                    {isEditing ? (
                      <Form.Control
                        size="sm"
                        value={editData.emergencyRelation}
                        onChange={(e) =>
                          handleInputChange('emergencyRelation', e.target.value)
                        }
                      />
                    ) : (
                      data?.emergencyRelation || 'N/A'
                    )}
                  </td>
                </tr>
                {/* <tr>
                  <td className="ps-4 fw-bold">
                    POSH Committee Member
                  </td>
                  <td>
                    {isEditing ? (
                      <div className="d-flex gap-4">
                        <label className="form-check d-flex align-items-center gap-2">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="isPoshCommitteeMember"
                            checked={editData.isPoshCommitteeMember === true}
                            onChange={(e) => {
                              handleInputChange('isPoshCommitteeMember', true)
                            }}
                          />
                          <span>Yes</span>
                        </label>
                        <label className="form-check d-flex align-items-center gap-2">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="isPoshCommitteeMember"
                            checked={editData.isPoshCommitteeMember === false}
                            onChange={(e) => {
                              handleInputChange('isPoshCommitteeMember', false)
                            }}
                          />
                          <span>No</span>
                        </label>
                      </div>
                    ) : (
                      data?.isPoshCommitteeMember ? 'Yes' : 'No'
                    )}
                  </td>
                </tr> */}
              </tbody>
            </table>
        </div>
    </div>

  )
}

export default UserDetailsTable




